import { render, staticRenderFns } from "./employeeCaseLoad.vue?vue&type=template&id=2e6298b9&"
import script from "./employeeCaseLoad.vue?vue&type=script&lang=js&"
export * from "./employeeCaseLoad.vue?vue&type=script&lang=js&"
import style0 from "./employeeCaseLoad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports